import { CompactTableColumn } from '../../components/data-display/ResponsiveDataView';
import { Machine } from '../../types/machines/machine.types';
import { MachineNameCell } from './MachineNameCell';
import { MachineStatusBadge } from './MachineStatusBadge';

/**
 * The tablet table's columns. Ids match the sort keys the machines query
 * accepts, so a tapped header reaches the backend unchanged.
 *
 * In a narrow pane the middle columns hide. The name and the status stay, which
 * is what the split layout's 380px master pane fits.
 */
export const MACHINE_TABLET_COLUMNS: CompactTableColumn<Machine>[] = [
  {
    id: 'displayName',
    header: 'Display name',
    sortable: true,
    className: 'w-1/2 @[42rem]:w-2/5',
    cell: (machine) => <MachineNameCell machine={machine} />,
  },
  {
    id: 'customerName',
    header: 'Client',
    sortable: true,
    className: 'hidden w-1/4 truncate @[30rem]:table-cell',
    cell: (machine) => (
      <span className='block truncate'>{machine.customerName}</span>
    ),
  },
  {
    id: 'family',
    header: 'Family',
    sortable: true,
    className: 'hidden w-32 @[42rem]:table-cell',
    cell: (machine) => <span className='block truncate'>{machine.family}</span>,
  },
  {
    id: 'status',
    header: 'Status',
    sortable: true,
    className: 'w-36 @[34rem]:w-48',
    cell: (machine) => (
      // The badge's own padding sits its text below the name's line. Lift it back.
      <MachineStatusBadge status={machine.status} className='-mt-1' />
    ),
  },
];
